import React from 'react';
import PropTypes from 'prop-types';

import Input from 'react-toolbox/lib/input/Input';

import {ThreeInputGroup} from '../../Styled';

const Request = ({name, setName, phone, setPhone, email, setEmail, message, setMessage}) => {
    return (
        <React.Fragment>
            <ThreeInputGroup>
                <Input type='text' label='Name' name='name' required autoComplete='name'
                       value={name} onChange={setName}/>
                <Input type='tel' label='Phone' name='phone' required autoComplete='tel'
                       value={phone} onChange={setPhone}/>
                <Input type='email' label='Email' name='email' required autoComplete='email'
                       value={email} onChange={setEmail}/>
            </ThreeInputGroup>
            <Input type='text' label='Message' name='message' required value={message} onChange={setMessage}/>
        </React.Fragment>
    );
};

Request.propTypes = {
    name:       PropTypes.string,
    setName:    PropTypes.func.isRequired,
    phone:      PropTypes.string,
    setPhone:   PropTypes.func.isRequired,
    email:      PropTypes.string,
    setEmail:   PropTypes.func.isRequired,
    message:    PropTypes.string,
    setMessage: PropTypes.func.isRequired
};

export default Request;



// WEBPACK FOOTER //
// ./src/app/contact/components/Request.js